export default __webpack_public_path__ + "static/media/Umbrella.54dbde57.png";